import { render, staticRenderFns } from "./PagesTaskGroupsShow.vue?vue&type=template&id=639834ec&scoped=true&"
import script from "./PagesTaskGroupsShow.vue?vue&type=script&lang=js&"
export * from "./PagesTaskGroupsShow.vue?vue&type=script&lang=js&"
import style0 from "./PagesTaskGroupsShow.vue?vue&type=style&index=0&id=639834ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639834ec",
  null
  
)

export default component.exports